<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" layout='inline'
    :onFinish='pageSearchChange'>
    <a-form-item label="关键词" name='keyword'>
      <a-input v-model:value="search.keyword" style='width:270px' placeholder="请输入手机号/会员ID进行搜索" />
    </a-form-item>
    <a-form-item label="短信内容" name='content'>
      <a-input v-model:value="search.content" style='width:270px' placeholder="请输入短信内容进行搜索" />
    </a-form-item>
    <a-form-item label="发送结果" name='status'>
      <a-select v-model:value="search.status" style='width: 120px;' placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option :value="0">失败</a-select-option>
        <a-select-option :value="1">成功</a-select-option>
        <a-select-option :value="2">发送中</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='phone' :columns='columns' :data-source='data'>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
</template>
<script>
  import { ref } from "vue";
  import { getSmsAgainList } from "@/api/message";
  import { iscode } from "@/utils/app";
  import { message } from 'ant-design-vue';
  const def = {
    limit: 5,
    page: 1,
    keyword: "",
    content:"",
    status:""
  };
  export default {
    setup(props, { emit }) {
      const search = ref({ ...def });
      const data = ref([]);
      const listLoading = ref(false);
      const total = ref(0);
      let columns = [
        {
          title: "手机号",
          dataIndex: "phone",
          key: "phone",
        },
        {
          title: "会员ID",
          dataIndex: "member_id",
          key: "member_id",
          customRender: ({ record }) => {
            return record.member_id ? record.member_id : '-'
          },
        },
        {
          title: "短信内容",
          dataIndex: "template_content",
          key: "template_content",
        },
        {
          title: "重发时间",
          dataIndex: "create_time",
          key: "create_time",
        },
        {
          title: "发送结果",
          dataIndex: "status_text",
          key: "status_text",
        }
      ];
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      // 初始化数据
      const initData = async (values) => {
        listLoading.value = true
        let result = await getSmsAgainList(values).then((res) => res.data).catch((error) => error);
        if (iscode(result)) {
          data.value = result.data.data;
          total.value = result.data.total;
        } else {
          message.error(result.msg);
        }
        listLoading.value = false
      };
      initData(search.value);
      return {
        search,
        columns,
        data,
        total,
        listLoading,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange
      };
    },
  };
</script>